export default function formatPhoneNumber (phoneNumber) {
  while(phoneNumber.length > 10) {
    phoneNumber = phoneNumber.substring(1, phoneNumber.length)
  }
  return phoneNumber
}